import React, { Component } from "react";
import styles from "./AccessibilitatModal.module.css";
import { Button, Modal } from "antd";

const navegarAlContingut = contingut => {
  const element = document.getElementById(contingut);
  if (element) {
    element.scrollIntoView();
  }
};

const clauIndex = "index";
const clauSecccioSituacio = "situacio";
const clauSecccioContingut = "contingut";
const clauSecccioPreparacio = "preparacio";
const clauSecccioObservacions = "observacions";
const clauSecccioSolicituds = "solicituds";
const clauSecccioProcediment = "preocediment";

class AccessibilitatModal extends Component {
  constructor(props) {
    super(props);
    this.state = { modalVisible: false };
    this.mostrarModal = this.mostrarModal.bind(this);
    this.amagarModal = this.amagarModal.bind(this);
  }

  mostrarModal() {
    this.setState({ ...this.state, modalVisible: true });
  }

  amagarModal() {
    this.setState({ ...this.state, modalVisible: false });
  }

  render() {
    const { modalVisible } = this.state;
    const titolModal = (
      <div className={styles.titolModal}>
        <h1>Declaració d'accessibilitat</h1>
      </div>
    );
    const botoPujarTaulaContinguts = (
      <a
        onClick={() => navegarAlContingut(clauIndex)}
        className={styles.botoPujar}
      >
        <Button icon="arrow-up">Pujar</Button>
      </a>
    );

    return (
      <div className={styles.accessibilitatLink}>
        <a
          onClick={this.mostrarModal}
          title="Accessibilitat (obre en finestra modal)"
          aria-label="Accessibilitat (obre en finestra modal"
        >
          Accessibilitat
        </a>
        <Modal
          wrapClassName={styles.Contenidor}
          visible={modalVisible}
          title={titolModal}
          closable={false}
          footer={[
            <Button key="entesos" type="primary" onClick={this.amagarModal}>
              Entesos
            </Button>
          ]}
        >
          <div className={styles.contingut}>
            <p>
              El <strong>Servei Meteorològic de Catalunya (SMC)</strong> s'ha
              compromès a fer accessibles els seus webs de conformitat amb el
              Reial Decret 1112/2018, de 7 de setembre, sobre accessibilitat
              dels llocs web i aplicacions per a dispositius mòbils del sector
              públic (en endavant, Reial Decret 1112/2018, de 7 de setembre).
            </p>
            <p>
              La present declaració d'accessibilitat s'aplica al web{" "}
              <strong>https://feno.gencat.cat</strong>
            </p>
            <nav id={clauIndex}>
              <strong>Taula de continguts</strong>
              <ul>
                <li>
                  <a onClick={() => navegarAlContingut(clauSecccioSituacio)}>
                    Situació de compliment
                  </a>
                </li>
                <li>
                  <a onClick={() => navegarAlContingut(clauSecccioContingut)}>
                    Contingut no accessible
                  </a>
                </li>
                <li>
                  <a onClick={() => navegarAlContingut(clauSecccioPreparacio)}>
                    Preparació de la present declaració d'accessibilitat
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => navegarAlContingut(clauSecccioObservacions)}
                  >
                    Observacions i dades de contacte
                  </a>
                </li>
                <li>
                  <a onClick={() => navegarAlContingut(clauSecccioSolicituds)}>
                    Sol·licituds d'informació accessible i queixes
                  </a>
                </li>
                <li>
                  <a onClick={() => navegarAlContingut(clauSecccioProcediment)}>
                    Procediment d'aplicació
                  </a>
                </li>
              </ul>
            </nav>
            <hr />
            <h2 id={clauSecccioSituacio}>Situació de compliment</h2>
            <p>
              Aquest lloc web és <strong>parcialment conforme</strong> amb el
              Reial Decret 1112/2018, de 7 de setembre, a causa de les
              excepcions i la manca de conformitat dels aspectes que s'indiquen
              a continuació.
            </p>
            {botoPujarTaulaContinguts}

            <h2 id={clauSecccioContingut}>Contingut no accessible</h2>
            <p>
              El contingut que es recull a continuació no és accessible pels
              següents motius:
            </p>
            <ul>
              <li>
                <strong>
                  Manca de conformitat amb el Reial Decret 1112/2018, de 7 de
                  setembre
                </strong>
                : Podrien existir diversos errors d'edició en alguna pàgina web,
                tant a continguts HTML com a documents finals, publicats amb
                data posterior al 20 de setembre de 2018.
              </li>
              <li>
                <strong>Càrrega desproporcionada</strong>: no aplica.
              </li>
              <li>
                <strong>
                  El contingut no entra dins de l'àmbit de la legislació
                  aplicable
                </strong>
                : podrien existir arxius ofimàtics en PDF o altres formats
                publicats abans del 20 de setembre de 2018 que no compleixin en
                la totalitat els requisits d'accessibilitat.
              </li>
            </ul>
            {botoPujarTaulaContinguts}

            <h2 id={clauSecccioPreparacio}>
              Preparació de la present declaració d'accessibilitat
            </h2>
            <p>
              La present declaració va ser preparada el 21 de juliol de 2021.
            </p>
            <p>
              El mètode utilitzat per preparar la declaració ha estat una
              autoavaluació portada a teme per el propi organisme.
            </p>
            <p>Darrera revisió de la declaració: 21 de juliol de 2021.</p>
            {botoPujarTaulaContinguts}

            <h2 id={clauSecccioObservacions}>
              Observacions i dades de contacte
            </h2>
            <p>
              Es poden realitzar comunicacions sobre requisits d'accessibilitat
              (article 10.2.a del Reial Decret 1112/2018), a través de la
              següent{" "}
              <a
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://ovt.gencat.cat/gsitfc/AppJava/generic/conqxsGeneric.do?topicLevel1.id=500&topicLevel2.id=20523&webFormId=391&set-locale=ca_ES"
                aria-label="Bústia de contacte (s'obre en finestra nova)"
              >
                bústia de contacte
              </a>
              .
            </p>
            <p>Per exemple:</p>
            <ul>
              <li>
                Informar sobre qualsevol possible incompliment per part d'aquest
                lloc web.
              </li>
              <li>Transmetre altres dificultats d'accés al contingut.</li>
              <li>
                Formular qualsevol altra consulta o suggeriment de millora
                relativa a l'accessibilitat del lloc web.
              </li>
            </ul>
            <p>
              Les comunicacions seran rebudes i traslladades per la Direcció
              General d'Atenció Ciutadana, del Departament de la
              Vicepresidència, Economia i Hisenda, com a Unitat Responsable
              d'Accessibilitat Web en l'àmbit autonòmic.
            </p>
            {botoPujarTaulaContinguts}

            <h2 id={clauSecccioSolicituds}>
              Sol·licituds d'informació accessible i queixes
            </h2>
            <p>
              Per fer sol·licituds d'informació accessible i queixes (article 12
              del Reial Decret 1112/2018) cal accedir al tràmit “
              <a
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="http://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web"
                aria-label="Accés al tràmit 'Continguts accessibles al web' (s'obre en finestra nova)"
              >
                Continguts accessibles al web
              </a>
              ” i seguir la modalitat “
              <a
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="http://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web"
                aria-label="Sol·licitar informació accessible o fer una queixa (s'obre en finestra nova)"
              >
                Sol·licitar informació accessible o fer una queixa
              </a>
              “.
            </p>
            <p>
              Qualsevol persona física o jurídica pot formular queixes relatives
              al compliment dels requisits del Reial Decret 1112/2018 i
              sol·licitar informació relativa a continguts que estiguin exclosos
              de l'àmbit d'aplicació d'aquesta normativa.
            </p>
            <p>
              Les sol·licituds i queixes es registren conforme als requisits
              establerts per la Llei 39/2015 d'1 d'octubre, del Procediment
              Administratiu Comú de les Administracions Públiques.
            </p>
            {botoPujarTaulaContinguts}

            <h2 id={clauSecccioProcediment}>Procediment d'aplicació</h2>
            <p>
              El procediment d'aplicació recollit a l'article 13 del Reial
              Decret 1112/2018 es pot iniciar al tràmit “
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web"
                aria-label="Accés al tràmit 'Continguts accessibles al web' (s'obre en finestra nova)"
              >
                Continguts accessibles al web
              </a>
              ” a través de la modalitat “
              <a
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="http://web.gencat.cat/ca/tramits/tramits-temes/Continguts-accessibles-al-web"
                aria-label="Reclamar una sol·licitud (s'obre en finestra nova)"
              >
                Reclamar una sol·licitud
              </a>
              “.
            </p>

            <p>
              Si un cop realitzada una sol·licitud d'informació accessible o
              queixa, aquesta ha estat desestimada, no estàs d'acord amb la
              decisió adoptada o la resposta no compleix amb els requisits de
              l'article 12.5 del RD 1112/2018, pots iniciar una reclamació per:
            </p>
            <ul>
              <li>Conèixer i oposar-te als motius de la desestimació.</li>
              <li>
                Instar a l'adopció de les mesures oportunes en cas de no estar
                d'acord amb la decisió adoptada.
              </li>
              <li>
                Exposar les raons per les quals consideres que la resposta no
                compleix amb els requisits exigits.
              </li>
            </ul>
            <p>
              També es pot iniciar una reclamació en cas que hagin transcorregut
              20 dies hàbils sense haver obtingut cap resposta.
            </p>
            {botoPujarTaulaContinguts}
          </div>
        </Modal>
      </div>
    );
  }
}

export default AccessibilitatModal;
